import axios from 'axios';
import config from '../config';
import { getBearerToken } from '../util/cookie';

// ── Action types ──
export const NOTIFICATIONS_REQUEST = 'app/CoachSaaS/NOTIFICATIONS_REQUEST';
export const NOTIFICATIONS_SUCCESS = 'app/CoachSaaS/NOTIFICATIONS_SUCCESS';
export const NOTIFICATIONS_ERROR = 'app/CoachSaaS/NOTIFICATIONS_ERROR';
export const NOTIFICATION_READ = 'app/CoachSaaS/NOTIFICATION_READ';
export const NOTIFICATIONS_ALL_READ = 'app/CoachSaaS/NOTIFICATIONS_ALL_READ';

const initialState = {
  items: [],
  unreadCount: 0,
  notificationsFetching: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case NOTIFICATIONS_REQUEST:
      return { ...state, notificationsFetching: true };
    case NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notificationsFetching: false,
        items: payload.items || [],
        unreadCount: payload.unreadCount || 0,
      };
    case NOTIFICATIONS_ERROR:
      return { ...state, notificationsFetching: false };
    case NOTIFICATION_READ:
      return {
        ...state,
        items: state.items.map(n => (n.id === payload ? { ...n, isRead: true } : n)),
        unreadCount: Math.max(0, state.unreadCount - 1),
      };
    case NOTIFICATIONS_ALL_READ:
      return {
        ...state,
        items: state.items.map(n => ({ ...n, isRead: true })),
        unreadCount: 0,
      };
    default:
      return state;
  }
}

// ── Thunks ──
export const fetchNotifications = () => async (dispatch, getState, sdk) => {
  dispatch({ type: NOTIFICATIONS_REQUEST });
  try {
    const res = await axios.get(`${config.coachSaaSService}client/notifications`, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    });
    dispatch({ type: NOTIFICATIONS_SUCCESS, payload: res.data || {} });
    return res.data;
  } catch (e) {
    dispatch({ type: NOTIFICATIONS_ERROR });
    throw e;
  }
};

export const markNotificationRead = (notificationId) => async (dispatch, getState, sdk) => {
  dispatch({ type: NOTIFICATION_READ, payload: notificationId });
  return axios.post(
    `${config.coachSaaSService}client/notifications/${notificationId}/read`,
    {},
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};

export const markAllNotificationsRead = () => async (dispatch, getState, sdk) => {
  dispatch({ type: NOTIFICATIONS_ALL_READ });
  return axios.post(
    `${config.coachSaaSService}client/notifications/read-all`,
    {},
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};
